<template>
	<toolbar>
		<h2>
			<i class="fa" :class="icon"></i>
			{{heading}}
		</h2>

		<div class="controls">
			<nav-tabs :tabs="tabs"
				mobile-breakpoint="1024"
				addon-apps-location="Health & Safety Module"
				addon-apps-link="/safety/apps">
			</nav-tabs>
		</div>
	</toolbar>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import NavTabs from "@/layout_fragments/NavTabs"

export default {
	name: "SafetyToolbar",
	components: {
		Toolbar,
		NavTabs
	},
	props: ["heading","icon"],
	data() {
		return {
		}
	},
	computed: {
		tabs() {
			let tabs = [
				{
					label: "Employee Certificates",
					path: "/safety/certificates/matrix",
					icon: "fa-id-card",
					modulePermRequired: ["Certificates"]
				}
			]

			if (this.hasModulePermWrite("Certificates")) {
				tabs.push({
					label: "Manage Certificates",
					path: "/safety/certificates/list",
					icon: "fa-id-card",
					modulePermRequired: ["Certificates"]
				})
			}

			/*tabs.push({
				label: "Safety Forms",
				path: "/safety/forms",
				icon: "fa-medkit"
			})

			if (this.hasModulePermWrite("Safety")) {
				tabs.push({
					label: "Form Templates",
					path: "/safety/form-templates",
					icon: "fa-cubes"
				})
			}*/

			return tabs
		}
	}
}
</script>